/* global $, window */

(function () {
    "use strict";

    function getState () {
        var width = $(window).width();

        var state = {
            tablets: false,
            phones: false,
            phonesVertical: false,
            phonesSmall: false,
            isMobilised: function () {
                return ($('.layout_mobilised').length);
            }
        };

        if (width <= 1060) {
            state.tablets = true;
        }
        if (width <= 767) {
            state.phones = true;
        }
        if (width <= 568) {
            state.phonesVertical = true;
        }
        if (width <= 360) {
            state.phonesSmall = true;
        }

        return state;
    }

    window.MediaQueryState = getState();
    $(window).on('resize.MediaQueryState', function () {
        window.MediaQueryState = getState();
    });
})();